// 統一檢查 service layer 回傳是否成功的 helper。
// 對齊本 repo 的 service 契約：失敗時應回 `{ success: false, errors?: [{ detail }], message? }`，
// 成功時回 `{ success: true, data? }`。某些 service 直接回 fetch raw body 沒帶 success，
// 走 `result?.success === true` 嚴格比對才不會把 4xx 誤判為成功（過去 PermissionsEditor 踩過）。

export interface ServiceResultLike {
  success?: boolean;
  message?: string;
  errors?: Array<{ detail?: string }>;
  [key: string]: unknown;
}

export type CheckedServiceResult =
  | { ok: true }
  | { ok: false; detail: string | null };

/**
 * 檢查 service 回傳是否成功，失敗時挑出最具體的錯誤訊息給 caller 顯示。
 *
 * @example
 *   const result = await templateService.upsert({ name, permissions });
 *   const check = checkServiceResult(result);
 *   if (!check.ok) {
 *     message.error(check.detail || t('default_failure_key'));
 *     return;
 *   }
 *   // ... happy path
 */
export function checkServiceResult(result: ServiceResultLike | null | undefined): CheckedServiceResult {
  if (result?.success === true) return { ok: true };
  const detail = result?.errors?.[0]?.detail || result?.message || null;
  return { ok: false, detail };
}
